export function parsePlaceResult(placeResult: google.maps.places.PlaceResult) {
  const addressComponents = placeResult.address_components || [];

  // Initialize the address parts
  let streetNumber = '';
  let route = '';
  let city = '';
  let state = '';
  let zip = '';

  // Extract each component based on their types
  addressComponents.forEach(component => {
    const types = component.types || [];

    if (types.includes('street_number')) {
      streetNumber = component.long_name;
    } else if (types.includes('route')) {
      route = component.long_name;
    } else if (types.includes('locality')) {
      city = component.long_name;
    } else if (types.includes('administrative_area_level_1')) {
      state = component.short_name;
    } else if (types.includes('postal_code')) {
      zip = component.long_name;
    }
  });

  return {
    streetAddress: `${streetNumber || ''} ${route || ''}`.trim(),
    streetAddress2: '', // This usually comes from a separate unit/apt input
    city: city || '',
    state: state || '',
    zip: zip || '',
  };
}
